//import liraries

// create a component
const Spinner = ({ type }) => {
  return <div className={`spinner ${type} spinner-center`} role="status" />;
};

//make this component available to the app
export default Spinner;
